import { ensureSubsetOfKeys } from '@daymade/common-lib/types';
import { zodSelectTreeLog } from '../generated/zodSchemas.generated';
import { z } from 'zod';

export const ZTreeLogSelect = zodSelectTreeLog
  .pick({
    id: true,
    playerId: true,
    action: true,
    refId: true,
    refKey: true,
  })
  .extend(
    ensureSubsetOfKeys(zodSelectTreeLog.shape, {
      createdAt: z.coerce.date(),
      orderId: z.string().optional().nullable(),
      quantity: z.number().optional().nullable(),
      additionalInfo: z.optional(z.unknown()),
    }),
  );
